import Vue from 'vue'
import moment from 'moment/moment'//下载npm i moment -s
// 日期过滤器
Vue.filter('moment1', function (value, formatString) {
    formatString = formatString || 'YYYY-MM-DD';
    if(value==null || value==''){

    }else{
        return moment.unix(value).format(formatString);
    }
});
Vue.filter('moment2', function (value, formatString) {
    formatString = formatString || 'YYYY-MM-DD HH:MM:SS';
    if(value==null || value==''){

    }else{
        return moment.unix(value).format(formatString);
    }
});


// WEBPACK FOOTER //
// ./src/common/uitil.js